var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { EventEmitter, OnInit } from '@angular/core';
var MembershipTierComponent = /** @class */ (function () {
    function MembershipTierComponent() {
        this.tier = undefined;
        this.selectedTierId = undefined;
        this.selectable = false;
        this.selected = new EventEmitter();
    }
    MembershipTierComponent.prototype.ngOnInit = function () { };
    MembershipTierComponent.prototype.select = function (tier, subtier) {
        var tierSelected = __assign({}, tier, { subtier: subtier });
        this.selected.emit(tierSelected);
    };
    MembershipTierComponent.prototype.membershipSubtierId = function (subtierId) {
        return subtierId;
    };
    return MembershipTierComponent;
}());
export { MembershipTierComponent };



// WEBPACK FOOTER //
// ./src/app/shared/membership-tier/membership-tier.component.ts.pre-build-optimizer.js